import type { SVGProps } from "react";

export function CloseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" {...props}>
      <path d="M24.4766 8.05048C25.1745 7.35264 25.1745 6.22122 24.4766 5.52338C23.7788 4.82554 22.6474 4.82554 21.9495 5.52338L15 12.4729L8.05048 5.52338C7.35264 4.82554 6.22122 4.82554 5.52338 5.52338C4.82554 6.22122 4.82554 7.35264 5.52338 8.05048L12.4729 15L5.52338 21.9495C4.82554 22.6474 4.82554 23.7788 5.52338 24.4766C6.22122 25.1745 7.35264 25.1745 8.05048 24.4766L15 17.5271L21.9495 24.4766C22.6474 25.1745 23.7788 25.1745 24.4766 24.4766C25.1745 23.7788 25.1745 22.6474 24.4766 21.9495L17.5271 15L24.4766 8.05048Z" />
    </svg>
  );
}
